var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "stats" }, [
    _c("div", { staticClass: "stats__header" }, [
      _c(
        "div",
        {
          staticClass:
            "ug-row ug-row--apearance_spaced ug-row--space_xs ug-row--justify_between ug-row--align_center"
        },
        [
          _c(
            "div",
            { staticClass: "ug-cell" },
            [
              _c(
                "text-bemto",
                {
                  attrs: {
                    fw: "bold",
                    lh: "initial",
                    fs: ["md", "1md-md", "xl-fhd"],
                    color: "black",
                    tag: "p"
                  }
                },
                [_vm._v("USEFUL PHONE NUMBERS")]
              )
            ],
            1
          ),
          _vm._m(0)
        ]
      )
    ]),
    _c("div", { staticClass: "stats__body" }, [
      _c(
        "div",
        { staticClass: "stats__content ma ma--b_md ma--b_1md-lg" },
        [
          _c(
            "text-bemto",
            {
              staticClass: "ma ma--b_xs",
              attrs: {
                fw: "medium",
                lh: "initial",
                fs: ["1xs"],
                color: "grey4",
                tag: "p"
              }
            },
            [_vm._v(_vm._s(_vm.objectItem.scheduleTechnician))]
          ),
          _c(
            "link-bemto",
            {
              staticClass: "c c--hover_common",
              attrs: {
                fw: "medium",
                lh: "initial",
                fs: ["1md", "xl-lg"],
                color: "black",
                href: "tel:" + _vm.objectItem.contactTechnician,
                tag: "a"
              }
            },
            [
              _vm._v(
                _vm._s(_vm.objectItem.nameTechnician) +
                  " - " +
                  _vm._s(_vm.objectItem.contactTechnician)
              )
            ]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "stats__content" },
        [
          _c(
            "text-bemto",
            {
              staticClass: "ma ma--b_xs",
              attrs: {
                fw: "medium",
                lh: "initial",
                fs: ["1xs"],
                color: "grey4",
                tag: "p"
              }
            },
            [_vm._v(_vm._s(_vm.objectItem.scheduleOffice))]
          ),
          _c(
            "link-bemto",
            {
              staticClass: "c c--hover_common",
              attrs: {
                fw: "medium",
                lh: "initial",
                fs: ["1md", "xl-lg"],
                color: "black",
                href: "tel:" + _vm.objectItem.contactOffice,
                tag: "a"
              }
            },
            [_vm._v(_vm._s(_vm.objectItem.contactOffice))]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ug-cell" }, [
      _c("div", { staticClass: "stats__icon icon icon--type_stats-phone" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-261fe2d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-261fe2d2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/Forms/cabinets/panels/NumbersPanel.vue
// module id = 946
// module chunks = 0